export const isMediaFile = (file: { mime?: string }): boolean =>
    !!file.mime && (
        file.mime.startsWith('image/') ||
        file.mime.startsWith('video/') ||
        file.mime.startsWith('audio/')
    );
